import { OwlOptions } from 'ngx-owl-carousel-o';

export const CATEGORY_CAROUSEL_OPTIONS: OwlOptions = {
  mouseDrag: false,
  touchDrag: true,
  pullDrag: false,
  navSpeed: 300,
  autoplay: false,
  nav: true /* NavData and dots will remain but the navigation is hidden on the main style file of the app */,
  dots: false,
  navText: [
    '<img class="category__carousel-btn-icon" src="https://fe-cdn.infra.metro-markets.cloud/images/icons/chevron-left-white.svg" />',
    '<img class="category__carousel-btn-icon" src="https://fe-cdn.infra.metro-markets.cloud/images/icons/chevron-right-white.svg" />',
  ],
  responsiveRefreshRate: 200,
  slideBy: 'page',
  slideTransition: 'ease-out',
  stagePadding: 0,
  responsive: {
    0: {
      items: 3,
      slideBy: 3,
    },
    864: {
      items: 4,
      slideBy: 4,
    },
    1024: {
      items: 5,
      slideBy: 5,
    },
    1280: {
      items: 6,
      slideBy: 6,
    },
  },
};

export const CATEGORY_CAROUSEL_NEWSTYLE_OPTIONS: OwlOptions = {
  mouseDrag: false,
  touchDrag: true,
  pullDrag: false,
  navSpeed: 300,
  autoplay: false,
  nav: true /* NavData and dots will remain but the navigation is hidden on the main style file of the app */,
  dots: false,
  navText: [
    '<img alt="carousel-arrow-left" class="category__carousel-btn-icon-newStyle" src="https://fe-cdn.infra.metro-markets.cloud/images/icons/chevron-small-left.svg" />',
    '<img alt="carousel-arrow-right" class="category__carousel-btn-icon-newStyle" src="https://fe-cdn.infra.metro-markets.cloud/images/icons/chevron-small-right.svg" />',
  ],
  responsiveRefreshRate: 200,
  slideBy: 'page',
  slideTransition: 'ease-out',
  stagePadding: 0,
  responsive: {
    0: {
      items: 3,
      slideBy: 3,
    },
    864: {
      items: 4,
      slideBy: 4,
    },
    1024: {
      items: 5,
      slideBy: 5,
    },
    1280: {
      items: 6,
      slideBy: 6,
    },
  },
};
